/*! @pentacode/ui v0.1.0 */
import { t as e } from "../../styledElement-Dm1irIE2.js";
import { t } from "../../decorateMetadata-BhwOl-pv.js";
import { t as n } from "../../decorate-DHgd5sZx.js";
import { FormElement as r } from "../formElement.js";
import { InputLabel as i } from "./input-label.js";
import { LitElement as a, html as o, nothing as s } from "lit";
import { customElement as c, property as l } from "lit/decorators.js";
//#region src/elements/form-elements/text-input.ts
var u = class extends e(r(a)) {
	constructor(...e) {
		super(...e), this.type = "text", this.name = "", this.label = void 0, this.placeholder = "", this.disabled = !1, this.required = !1, this.readonly = !1, this.pattern = void 0, this.maxlength = void 0, this.minlength = void 0, this.min = void 0, this.max = void 0, this.step = void 0;
	}
	handleInput(e) {
		let t = e.target;
		this.value = t.value, this.dispatchEvent(new CustomEvent("input", {
			detail: { value: t.value },
			bubbles: !0,
			composed: !0
		}));
	}
	handleChange(e) {
		let t = e.target;
		this.value = t.value, this.dispatchEvent(new CustomEvent("change", {
			detail: { value: t.value },
			bubbles: !0,
			composed: !0
		}));
	}
	handleFocus() {
		this.dispatchEvent(new CustomEvent("focus", {
			bubbles: !0,
			composed: !0
		}));
	}
	handleBlur() {
		this.dispatchEvent(new CustomEvent("blur", {
			bubbles: !0,
			composed: !0
		}));
	}
	render() {
		return o`
            <div class="w-full">
                ${this.label ? i(this.label) : s}
                <input
                    type="${this.type}"
                    name="${this.name}"
                    .value="${this.value || ""}"
                    placeholder="${this.placeholder}"
                    ?disabled="${this.disabled}"
                    ?required="${this.required}"
                    ?readonly="${this.readonly}"
                    pattern="${this.pattern || ""}"
                    maxlength="${this.maxlength || ""}"
                    minlength="${this.minlength || ""}"
                    min="${this.min || ""}"
                    max="${this.max || ""}"
                    step="${Number(this.step) || 1}"
                    @input=${this.handleInput}
                    @change=${this.handleChange}
                    @focus=${this.handleFocus}
                    @blur=${this.handleBlur}
                    class="focus:ring-opacity-50 ${this.readonly ? "bg-gray-50 text-gray-600 select-none cursor-default" : ""} w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm placeholder-gray-400 transition-colors duration-200 focus:border-[var(--brand-blue)] focus:outline-none disabled:cursor-not-allowed disabled:bg-gray-100"
                />
            </div>
        `;
	}
};
n([l({ type: String }), t("design:type", String)], u.prototype, "type", void 0), n([l({ type: String }), t("design:type", Object)], u.prototype, "name", void 0), n([l({ type: String }), t("design:type", Object)], u.prototype, "label", void 0), n([l({ type: String }), t("design:type", Object)], u.prototype, "placeholder", void 0), n([l({ type: Boolean }), t("design:type", Object)], u.prototype, "disabled", void 0), n([l({ type: Boolean }), t("design:type", Object)], u.prototype, "required", void 0), n([l({ type: Boolean }), t("design:type", Object)], u.prototype, "readonly", void 0), n([l({ type: String }), t("design:type", Object)], u.prototype, "pattern", void 0), n([l({ type: Number }), t("design:type", Object)], u.prototype, "maxlength", void 0), n([l({ type: Number }), t("design:type", Object)], u.prototype, "minlength", void 0), n([l({ type: String }), t("design:type", Object)], u.prototype, "min", void 0), n([l({ type: String }), t("design:type", Object)], u.prototype, "max", void 0), n([l({ type: String }), t("design:type", Object)], u.prototype, "step", void 0), u = n([c("ptc-ui-text-input")], u);
//#endregion
export { u as TextInput };

//# sourceMappingURL=text-input.js.map